import React from 'react';
import ReactDOM from 'react-dom/client';
import { App } from 'features';
import reportWebVitals from './reportWebVitals';
import { PymProvider } from '@telescope/cassini-hooks';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';

import { queryClient } from 'lib';

if (process.env.REACT_APP_BUILD !== 'true' && process.env.REACT_APP_MOCK_REQUESTS === 'true') {
  const { worker } = require('./mocks/browser');
  worker.start();
}

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <PymProvider>
      <QueryClientProvider client={queryClient}>
        <ReactQueryDevtools />
        <App />
      </QueryClientProvider>
    </PymProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
